import { useRef } from 'react';
import { useRouter } from 'next/router';
import { SwiperSlide, Swiper } from 'swiper/react';
import { Swiper as SwiperType, Navigation, Pagination } from 'swiper';

import { AscTrackCard } from '@ascendnow/ascend-components';
import { PLATFORM_ROUTES } from '@platform/constants';

import { useAppSelector } from '../../store';
import styles from '../../styles/pages/home.module.scss';
import IllustrationInternship from '../../assets/illustrations/internshipTrackIllustration.png';
import IllustrationEntrePreneurship from '../../assets/illustrations/enterTrackIllustation.png';
import IllustrationPreSkill from '../../assets/illustrations/firstDashIllustration.png';

const calculatePercentOfActivities = (all: number, completed: number) =>
    completed > 0 ? +((completed / all) * 100)?.toFixed(2) : 0;

export const AscDashboardTracks = () => {
    const router = useRouter();
    const swiperRef = useRef<SwiperType>();
    const { trackProgress, fetchingTrackProgress } = useAppSelector((state) => state.dashboard.dashboard);

    const certainPercentToDisplayCard = 50;

    const prerequisiteSkillsCompletedPercent = calculatePercentOfActivities(
        trackProgress.prerequisiteSkills?.modules,
        trackProgress.prerequisiteSkills?.passedModules
    );
    const entrepreneurshipTrackCompletedPrecent = calculatePercentOfActivities(
        trackProgress.entrepreneurshipTrack?.modules,
        trackProgress.entrepreneurshipTrack?.passedModules
    );
    const internshipTrackCompletedPercent = calculatePercentOfActivities(
        trackProgress.internshipTrack?.modules,
        trackProgress.internshipTrack?.passedModules
    );

    return (
        <Swiper
            slidesPerView="auto"
            spaceBetween={20}
            pagination={{ clickable: true }}
            modules={[Navigation, Pagination]}
            onBeforeInit={(swiper) => {
                swiperRef.current = swiper;
            }}
            className={styles.trackProgressCardList}
        >
            <SwiperSlide style={{ width: 'auto' }}>
                <AscTrackCard
                    loading={fetchingTrackProgress}
                    title="Pre-Requisite Skills"
                    imageUrl={IllustrationPreSkill.src}
                    completedPercentage={prerequisiteSkillsCompletedPercent}
                    totalModules={trackProgress?.prerequisiteSkills?.modules || 0}
                    completedModules={trackProgress?.prerequisiteSkills?.passedModules || 0}
                    locked={prerequisiteSkillsCompletedPercent < certainPercentToDisplayCard}
                    isSkillCardForDashboard
                    className={styles.skillCard}
                    onButtonClick={() => router.push(PLATFORM_ROUTES.skills)}
                />
            </SwiperSlide>
            <SwiperSlide style={{ width: 'auto' }}>
                <AscTrackCard
                    loading={fetchingTrackProgress}
                    title="Entrepreneurship Track"
                    imageUrl={IllustrationEntrePreneurship.src}
                    completedPercentage={entrepreneurshipTrackCompletedPrecent}
                    totalModules={trackProgress?.entrepreneurshipTrack?.modules}
                    completedModules={trackProgress?.entrepreneurshipTrack?.passedModules}
                    locked={entrepreneurshipTrackCompletedPrecent < certainPercentToDisplayCard}
                    isSkillCardForDashboard
                    className={styles.skillCard}
                    onButtonClick={() => router.push(PLATFORM_ROUTES.tracks_entrepreneurship_track)}
                />
            </SwiperSlide>
            <SwiperSlide style={{ width: 'auto' }}>
                <AscTrackCard
                    loading={fetchingTrackProgress}
                    title="Internship Track"
                    imageUrl={IllustrationInternship.src}
                    completedPercentage={internshipTrackCompletedPercent}
                    totalModules={trackProgress?.internshipTrack?.modules}
                    completedModules={trackProgress?.internshipTrack?.passedModules}
                    locked={internshipTrackCompletedPercent < certainPercentToDisplayCard}
                    isSkillCardForDashboard
                    className={styles.skillCard}
                    onButtonClick={() => router.push(PLATFORM_ROUTES.tracks_internship_track)}
                />
            </SwiperSlide>
        </Swiper>
    );
};
